import { useQueryClient } from '@tanstack/react-query';
import { Spinner } from '@bifeai/ui';
import { Navigate, useNavigate } from 'react-router';
import { ChangePasswordForm } from '../../components/ChangePasswordForm';
import { reloadMe, useMeQuery } from '../../lib/session';
import { AuthLayout } from './AuthLayout';

/** Primer ingreso con contraseña temporal: hay que elegir una propia. */
export function ChangePasswordPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const me = useMeQuery();

  if (me.isPending)
    return (
      <div className="bf-center-screen">
        <Spinner />
      </div>
    );
  if (me.isError) return <Navigate to="/ingresar" replace />;
  if (!me.data.session.mfaVerified) return <Navigate to="/ingresar/codigo" replace />;
  if (!me.data.user.mustChangePassword) return <Navigate to="/" replace />;

  return (
    <AuthLayout title="Elegí tu contraseña" subtitle="Ingresaste con una contraseña temporal. Cambiala por una que solo sepas vos.">
      <ChangePasswordForm
        currentLabel="Contraseña temporal"
        submitLabel="Guardar y entrar"
        onDone={async () => {
          await reloadMe(qc);
          navigate('/', { replace: true });
        }}
      />
    </AuthLayout>
  );
}
